var _path, _path2;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Eye = function Eye(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-1 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 4C7.52 4 3.907 6.647 1.132 11.504a1 1 0 0 0 0 .992C3.907 17.353 7.52 20 12 20s8.093-2.647 10.868-7.504a1 1 0 0 0 0-.992C20.093 6.647 16.48 4 12 4Zm0 14c-3.387 0-6.342-1.87-8.84-6C5.658 7.87 8.613 6 12 6c3.387 0 6.342 1.87 8.84 6-2.498 4.13-5.453 6-8.84 6Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default Eye;